import { Button, Grid, Typography } from "@mui/material";
import "../AppMobileXS.css";

export default function Card2() {
    return (
        <Grid container size={12} sx={{width: '70%', marginLeft: '40%', marginTop: '15vh'}}>
            <Grid item  size={3.9} sx={{textAlign: 'left'}}>
                <div className="stile-titolo bianco">JASMINE <br/>PASQUA</div>
                <div style={{marginTop: '10px'}} className="stile-sottotitolo bianco">sono una chinesiologa laureata in scienze delle attività motorie e sportive e specializzata nella ginnastica posturale</div>
            </Grid>
        </Grid>
    );
}
